import BossModel from "@/models/BossModel";

export default class Classification extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'flight/classification';

    /**
     *
     * @type {string}
     */
    static entity = 'flightClassifications';

    static fields() {
		return {
			id: this.number(null).nullable(),
			code: this.attr(null),
			name: this.attr(null),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll(){
        return this.api()
            .limit(0)
            .get(true);
    }


    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get(true);
    }
}
